export const home = {
  trackYourMatches: 'Track your matches',
  startRecording: 'Start Recording',
  recordNewMatch: 'Record New Match',
  trackYourLatestGame: 'Track your latest game',
  realTimeScoring: 'On-Court Tool',
  liveScoreboard: 'Score Tracker',
  trackPointsInRealTime: 'Track the score as you play',
  manageTournaments: 'Manage Tournaments',
  viewAndCreateTournaments: 'View and create tournaments',
  recentMatches: 'Recent Matches',
  noMatchesYet: 'No matches yet',
  noMatchesDescription: 'Record your first match to start tracking.',
  recordAMatch: 'Record a Match',
  pickupTitle: 'Pickup Games',
  pickupSubtitle: 'Find a hit, build your week',
  pickupEyebrow: 'Real-Time Posts',
  leaderboardTitle: 'Leaderboard',
  leaderboardSubtitle: 'See where you stand',
  leaderboardEyebrow: 'Global Ranking',
  pendingConfirmations: '{{count}} match{{count, plural, =1 {} other {es}}} need your confirmation',
  leagueEyebrow: 'Acework Ranked',
  leagueTitle: 'Monthly League',
  leagueSubtitle: '5 matches a month · climb your rating',
  clubsEyebrow: 'Communities',
  clubsTitle: 'Clubs',
  clubsSubtitle: 'Join or start a tennis community',
  myClubs: 'My Clubs',
  seeAll: 'See all ›',
  enableNotifications: 'Enable Notifications',
  enableNotificationsDesc: 'Get notified when someone joins your pickup or tournament',
};
